/**
 * Chart palette (validated categorical order + reserved status colors).
 * Categorical hues are assigned in fixed order and never cycled.
 */
export interface IChartPalette {
    series: string[];
    status: { good: string; warning: string; serious: string; critical: string };
    muted: string;
    grid: string;
    text: string;
    surface: string;
}

export const getChartPalette = (mode: 'light' | 'dark'): IChartPalette =>
    mode === 'dark'
        ? {
              series: ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300', '#9085e9', '#e66767'],
              status: { good: '#0ca30c', warning: '#fab219', serious: '#ec835a', critical: '#d03b3b' },
              muted: '#898781',
              grid: '#2c2c2a',
              text: '#c3c2b7',
              surface: '#1a1a19',
          }
        : {
              series: ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948'],
              status: { good: '#0ca30c', warning: '#fab219', serious: '#ec835a', critical: '#d03b3b' },
              muted: '#898781',
              grid: '#e1e0d9',
              text: '#52514e',
              surface: '#fcfcfb',
          };

/** Sequential blue ramp (light → dark) for magnitude encodings. */
export const BLUE_RAMP = ['#cde2fb', '#9ec5f4', '#6da7ec', '#3987e5', '#2a78d6', '#1c5cab', '#104281'];

export const withAlpha = (hex: string, alpha: number): string => {
    const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.trim());
    if (!m) return hex;
    return `rgba(${parseInt(m[1], 16)}, ${parseInt(m[2], 16)}, ${parseInt(m[3], 16)}, ${alpha})`;
};
